import React, { useEffect, useState, useRef } from "react"
import MetaTags from "react-meta-tags"
import PropTypes from "prop-types"
import { withRouter, Link, useLocation } from "react-router-dom"
import { isEmpty, set } from "lodash"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory, {
  PaginationListStandalone,
  PaginationProvider,
} from "react-bootstrap-table2-paginator"

// import DeleteModal from "../../../components/Common/DeleteModal";

import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"

import {
  Card,
  CardBody,
  Col,
  Container,
  Row
} from "reactstrap"

//redux
import { useSelector, useDispatch } from "react-redux"

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb"
import SweetAlert from "react-bootstrap-sweetalert";


import {
  convertToOrder,
  getOrders as onGetOrders,
} from "store/actions"

// import OrdersOrdersModal from "./OrderOrdersModal"
import Columns from "./Columns"
import { expandRow } from "./orderDetails"
import FilterComponentForOrders from "components/Common/filterComponentForOrders"
import { removeEmptyValues } from "common/CommonFunction"

const ViewRecords = props => {
  const dispatch = useDispatch()
  let location = useLocation()

  const { orders } = useSelector(state => ({
    orders: state.Orders.orders,
  }))

  const paginate = { size: 50, page: 1 }


  const [path, setPath] = useState("")
  const [filter, setFilter] = useState({})
  const [pageOptions, setPageOptions] = useState({
    sizePerPage: paginate.size,
    page: paginate.page,
    totalSize: paginate.size,
    custom: true,
  })
  const [alert, setAlert] = useState(null);


  useEffect(() => {
    if (orders?.docs) {
      setPageOptions({
        sizePerPage: orders.limit || paginate.size,
        page: orders.offset || paginate.page,
        totalSize: orders.totalDocs || 0,
        custom: true,
      })
    }
  }, [orders])


  const handlePage = json => {
    let locPath = location.pathname.split("/")[2];
    switch (locPath) {
      case "view-vectors":
      case "view-orders":
      case "view-quotes":
        dispatch(onGetOrders(json))
        break
      case "view-quotes":
        json.params.orderStatus = "New"
        dispatch(onGetOrders(json))
        break
      case "ready-quotes":
        json.params.orderStatus = "Done"
        dispatch(onGetOrders(json))
        break

      default:
        break
    }
  }

  useEffect(() => {
    data()
  }, [location])

  useEffect(() => {
    if (!orders.hasOwnProperty("docs")) {
      data()
    }
  }, [orders])

  const data = () => {
    let pth = "";

    switch (location.pathname.split("/")[2]) {
      case "view-quotes":
        pth = "quote";
        break;

      case "view-orders":
        pth = "order";
        break;

      case "view-vectors":
        pth = "vector";
        break;

      default:
        break;
    }

    if (pth) {
      setPath(pth);
      dispatch(onGetOrders(filterFunction(1, pth)))

    }
  };

  var node = useRef()

  const defaultSorted = [
    {
      dataField: "orderId",
      order: "desc",
    },
  ]


  function handleFilterClick(searchParam) {

    let json = removeEmptyValues(JSON.parse(JSON.stringify(searchParam)))
    setFilter(json)
    json = {
      params: { requestFor: path, delete: "false", ...json },
      paginate: { size: 50, page: 1 },
    }
    // console.log("handleFilterClick", json)
    handlePage(json)
  }

  function filterFunction(page, pth) {
    const queryParams = new URLSearchParams(location.search)

    const params = { requestFor: pth, delete: "false", ...filter }

    for (let [key, value] of queryParams.entries()) {
      params[key] = value
    }

    params.page = params.page > 1 ? params.page : page
    delete params.size

    let json = { params, paginate: { size: paginate.size, page: params.page } }
    return json
  }


  const handleConfirm = (orderCode) => {
    setAlert(<SweetAlert
      warning
      confirmBtnText="Yes, please!"
      cancelBtnText="Cancel"
      confirmBtnBsStyle="danger"
      title="Do you really want to convert this quote to order?"
      onConfirm={() => {
        dispatch(convertToOrder({ requestFor: "order", orderCode, convertToOrder: true, orderStatus: "New", price: 0, convertToOrderDate: new Date() }))
        setAlert(null)
      }}
      onCancel={() => setAlert(null)}
      focusCancelBtn
    >
    </SweetAlert>)
  };



  return (
    <React.Fragment>

      <div className="page-content">
        <MetaTags>
          <title>Orders</title>
        </MetaTags>
        <Container fluid>
          {alert}
          {/* <Breadcrumbs title={path.charAt(0).toUpperCase() + path.slice(1)} breadcrumbItem={slugToTitle(location.pathname.split("/")[2])} /> */}
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <PaginationProvider
                    pagination={paginationFactory(pageOptions)}
                    keyField="_id"
                    columns={Columns(handleConfirm)}
                    data={orders.hasOwnProperty("docs") ? orders.docs : orders}
                  // cellEdit={ cellEditFactory({ mode: 'click' }) }
                  >
                    {({ paginationProps, paginationTableProps }) => (
                      <ToolkitProvider
                        keyField="_id"
                        data={
                          orders.hasOwnProperty("docs") ? orders.docs : orders
                        }
                        columns={Columns(handleConfirm)}
                        bootstrap4
                      >
                        {toolkitProps => (
                          <React.Fragment>
                            <Col sm="12">
                              <FilterComponentForOrders
                                handleFilterClick={handleFilterClick}
                              />
                            </Col>
                            <Row>
                              <Col xl="12">
                                <div className="table-responsive">
                                  <BootstrapTable
                                    remote={{
                                      filter: true,
                                      pagination: true,
                                      sort: false,
                                      cellEdit: false,
                                    }}
                                    keyField="_id"
                                    responsive
                                    bordered={false}
                                    striped={false}
                                    defaultSorted={defaultSorted}
                                    // selectRow={selectRow}
                                    classes={
                                      "table align-middle table-nowrap table-check"
                                    }
                                    headerWrapperClasses={"table-light"}
                                    {...toolkitProps.baseProps}
                                    {...paginationTableProps}
                                    expandRow={expandRow}
                                    ref={node}
                                    onTableChange={(type, { page, sizePerPage }) => {
                                      handlePage({
                                        params: { requestFor: path, delete: "false", ...filter },
                                        paginate: { size: sizePerPage, page }
                                      })
                                    }}
                                  />
                                </div>
                              </Col>
                            </Row>.
                            <Row className="align-items-md-center mt-30">
                              <Col className="pagination pagination-rounded justify-content-end mb-2 inner-custom-pagination">
                                <PaginationListStandalone
                                  {...paginationProps}
                                />
                              </Col>
                            </Row>
                          </React.Fragment>
                        )}
                      </ToolkitProvider>
                    )}
                  </PaginationProvider>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

ViewRecords.propTypes = {
  orders: PropTypes.array,
  onGetOrders: PropTypes.func,
  onAddNewOrder: PropTypes.func,
  onDeleteOrder: PropTypes.func,
  onUpdateOrder: PropTypes.func,
}

export default withRouter(ViewRecords)
